import { IconComponent } from '@graftcode/design-system'

import { SEARCH_MODAL_TEST_IDS } from '@common/common-test-ids.const'

import { SEARCH_MODAL_ICON_MAP, SEARCH_MODAL_ITEM_KIND } from '../search-modal.const'
import type { SearchModalItemKind } from '../search-modal.type'

import styles from '../SearchModal.module.scss'

type SearchRowIconProps = {
  kind?: SearchModalItemKind
}

export function SearchRowIcon({ kind }: SearchRowIconProps) {
  const icon = SEARCH_MODAL_ICON_MAP[kind ?? SEARCH_MODAL_ITEM_KIND.Documentation]

  return (
    <span
      className={styles.rowIconWrap}
      data-testid={SEARCH_MODAL_TEST_IDS.rowIcon}
      data-row-icon={kind ?? SEARCH_MODAL_ITEM_KIND.Documentation}
    >
      <IconComponent icon={icon} className={styles.rowIconSvg} size={20} />
    </span>
  )
}
